export default "__VITE_ASSET__LBsZ79Ag__"